import React, { useState } from "react";
import ReactDOM from "react-dom";
import { galleryData } from "../../shared/galleryData";
import GalleryModal from "../galleryModal/GalleryModal";
import "./ChatbotGalleryStrip.css";

const PREVIEW_COUNT = 6;

const ChatbotGalleryStrip = ({ projectId, theme }) => {
  const [modalIndex, setModalIndex] = useState(null);

  const items = galleryData[projectId];
  if (!items || items.length === 0) return null;

  const previewItems = items.slice(0, PREVIEW_COUNT);
  const remaining = items.length - PREVIEW_COUNT;
  const accent = theme?.imageHighlight || "#6366f1";

  return (
    <>
      <div className="chatbot-gallery-strip">
        {previewItems.map((item, i) => (
          <button
            key={i}
            className="chatbot-gallery-thumb"
            onClick={() => setModalIndex(i)}
            aria-label={`View screenshot ${i + 1} of ${projectId}`}
          >
            {item.type === "video" ? (
              <div className="chatbot-gallery-video-placeholder">
                <span>▶</span>
              </div>
            ) : (
              <img
                src={item.src}
                alt={`${projectId} screenshot ${i + 1}`}
                loading="lazy"
              />
            )}
          </button>
        ))}

        {remaining > 0 && (
          <button
            className="chatbot-gallery-thumb chatbot-gallery-more"
            style={{
              "--gallery-accent": accent,
              borderColor: accent,
              color: accent,
            }}
            onClick={() => setModalIndex(PREVIEW_COUNT)}
            aria-label={`View ${remaining} more screenshots`}
          >
            +{remaining}
          </button>
        )}
      </div>

      {modalIndex !== null &&
        ReactDOM.createPortal(
          <GalleryModal
            items={items}
            startIndex={modalIndex}
            onClose={() => setModalIndex(null)}
          />,
          document.body
        )}
    </>
  );
};

export default ChatbotGalleryStrip;
